module.exports = __webpack_public_path__ + "static/media/plan.ebda091f.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageSecAwarenrssSolution/plan.png
// module id = 620
// module chunks = 0